module.exports = __webpack_public_path__ + "img/u5.a6ba2009.jpg";